function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_28",
  "data-name": "Group 28",
  transform: "translate(-1 -1)"
}, React.createElement("g", {
  id: "Group_27",
  "data-name": "Group 27",
  transform: "translate(0 0)"
}, React.createElement("path", {
  id: "Path_4112",
  "data-name": "Path 4112",
  d: "M22.6,20.6H21.4V-.6A.378.378,0,0,0,21-1H1a.378.378,0,0,0-.4.4V20.6H-.6A.378.378,0,0,0-1,21v1.6a.378.378,0,0,0,.4.4H22.6a.378.378,0,0,0,.4-.4V21A.378.378,0,0,0,22.6,20.6ZM1.4-.2H20.6V20.6h-6V16.2a.378.378,0,0,0-.4-.4H7.8a.378.378,0,0,0-.4.4v4.4h-6ZM8.2,20.6v-4h2.4v4Zm3.2-4h2.4v4H11.4Zm10.8,5.6H-.2v-.8H22.2v.8Z",
  transform: "translate(1 1)",
  fill: "#56AAFE"
}), React.createElement("path", {
  id: "Path_4113",
  "data-name": "Path 4113",
  d: "M86.535,40.967h-3.2a.378.378,0,0,0-.4.4v2.4a.378.378,0,0,0,.4.4h3.2a.378.378,0,0,0,.4-.4v-2.4A.378.378,0,0,0,86.535,40.967Zm-.4,2.4h-2.4v-1.6h2.4Z",
  transform: "translate(-78.935 -38.967)",
  fill: "#56AAFE"
}), React.createElement("path", {
  id: "Path_4114",
  "data-name": "Path 4114",
  d: "M86.535,133.295h-3.2a.378.378,0,0,0-.4.4v2.4a.378.378,0,0,0,.4.4h3.2a.378.378,0,0,0,.4-.4v-2.4A.378.378,0,0,0,86.535,133.295Zm-.4,2.4h-2.4v-1.6h2.4Z",
  transform: "translate(-78.935 -126.895)",
  fill: "#56AAFE"
}), React.createElement("path", {
  id: "Path_4115",
  "data-name": "Path 4115",
  d: "M209.236,136.5h3.2a.378.378,0,0,0,.4-.4v-2.4a.378.378,0,0,0-.4-.4h-3.2a.378.378,0,0,0-.4.4v2.4A.378.378,0,0,0,209.236,136.5Zm.4-2.4h2.4v1.6h-2.4Z",
  transform: "translate(-198.836 -126.896)",
  fill: "#56AAFE"
}), React.createElement("path", {
  id: "Path_4116",
  "data-name": "Path 4116",
  d: "M335.138,136.5h3.2a.378.378,0,0,0,.4-.4v-2.4a.378.378,0,0,0-.4-.4h-3.2a.378.378,0,0,0-.4.4v2.4A.378.378,0,0,0,335.138,136.5Zm.4-2.4h2.4v1.6h-2.4Z",
  transform: "translate(-318.738 -126.896)",
  fill: "#56AAFE"
}), React.createElement("path", {
  id: "Path_4117",
  "data-name": "Path 4117",
  d: "M209.236,228.824h3.2a.378.378,0,0,0,.4-.4v-2.4a.378.378,0,0,0-.4-.4h-3.2a.378.378,0,0,0-.4.4v2.4A.378.378,0,0,0,209.236,228.824Zm.4-2.4h2.4v1.6h-2.4Z",
  transform: "translate(-198.836 -214.824)",
  fill: "#56AAFE"
}), React.createElement("path", {
  id: "Path_4118",
  "data-name": "Path 4118",
  d: "M335.138,228.824h3.2a.378.378,0,0,0,.4-.4v-2.4a.378.378,0,0,0-.4-.4h-3.2a.378.378,0,0,0-.4.4v2.4A.378.378,0,0,0,335.138,228.824Zm.4-2.4h2.4v1.6h-2.4Z",
  transform: "translate(-318.738 -214.824)",
  fill: "#56AAFE"
}), React.createElement("path", {
  id: "Path_4119",
  "data-name": "Path 4119",
  d: "M86.535,225.623h-3.2a.378.378,0,0,0-.4.4v2.4a.378.378,0,0,0,.4.4h3.2a.378.378,0,0,0,.4-.4v-2.4A.378.378,0,0,0,86.535,225.623Zm-.4,2.4h-2.4v-1.6h2.4Z",
  transform: "translate(-78.935 -214.823)",
  fill: "#56AAFE"
}), React.createElement("path", {
  id: "Path_4120",
  "data-name": "Path 4120",
  d: "M209.236,44.168h3.2a.378.378,0,0,0,.4-.4v-2.4a.378.378,0,0,0-.4-.4h-3.2a.378.378,0,0,0-.4.4v2.4A.378.378,0,0,0,209.236,44.168Zm.4-2.4h2.4v1.6h-2.4Z",
  transform: "translate(-198.836 -38.968)",
  fill: "#56AAFE"
}), React.createElement("path", {
  id: "Path_4121",
  "data-name": "Path 4121",
  d: "M335.138,44.168h3.2a.378.378,0,0,0,.4-.4v-2.4a.378.378,0,0,0-.4-.4h-3.2a.378.378,0,0,0-.4.4v2.4A.378.378,0,0,0,335.138,44.168Zm.4-2.4h2.4v1.6h-2.4Z",
  transform: "translate(-318.738 -38.968)",
  fill: "#56AAFE"
}), React.createElement("path", {
  id: "Path_4122",
  "data-name": "Path 4122",
  d: "M192.45,318.752h4.8a.4.4,0,1,0,0-.8h-4.8a.4.4,0,1,0,0,.8Z",
  transform: "translate(-182.85 -302.752)",
  fill: "#56AAFE"
})));

var SvgBuilding2 = function SvgBuilding2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "building",
    transform: "translate(1 1)",
    style: {
      isolation: "isolate"
    }
  }, _ref2));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBuilding2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/building2.fcf018e5.svg";
export { ForwardRef as ReactComponent };